import React from 'react';
import { Form } from '@unform/web';
import UndoIcon from '@material-ui/icons/ArrowBackIos';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import CalendarIcon from '@material-ui/icons/CalendarTodayOutlined';
import InfoIcon from '@material-ui/icons/Info';
import Grid from '@material-ui/core/Grid';
import { Link, useParams } from 'react-router-dom';
import { FiMail, FiPhone } from 'react-icons/fi';
import { OptionTypeBase } from 'react-select';
import Select from '../../../components/Inputs/Select';
import Input from '../../../components/Inputs/Input';
import InputMasked from '../../../components/Inputs/InputMask';
import TextArea from '../../../components/Inputs/TextArea';
import DateTime from '../../../components/Inputs/DateTime';
import CheckboxInput from '../../../components/Inputs/ControlledCheckbox';
import Loading from '../../../components/Loading';
import BotaoSalvar from '../../../components/Botoes/BotaoSalvar';
import BotaoNovoPedidoRodape from '../../../components/Botoes/BotaoNovoPedidoRodape';
import StatusSincronizacao from '../../../components/Sincronizacao/MostraStatusSincronizacao';
import ModalPesquisaEndereco from '../../../components/Modal/ModalPesquisaEndereco';
import Can from '../../../components/Can';
import { Container, Separador } from '../../../styles/GlobalStyles';
import { tipoPessoa, freqOptions } from '../../../config/Basicos';
import retornaObjeto from '../../../utils/buscaObjeto';
import {
  HeaderCadastro,
  BodyCadastro,
  FooterCadastro,
  Voltar,
  Inline,
  ContainerInfo,
  TextInfo,
  TextEvento,
} from './styles';
import { useClienteCadastro } from './useClienteCadastro';
import { statusOptions, CNPJ_FORMAT_CHARS } from './helpers/constants';
import { getPessoaConfig, periodicidadeParaTexto } from './helpers/helpers';
import { STRINGS } from './helpers/strings';
import 'react-confirm-alert/src/react-confirm-alert.css';

interface IRouteParam {
  id?: string;
}

const CadastroClientes: React.FC = () => {
  const { id } = useParams<IRouteParam>();
  const {
    formRef,
    isLoading,
    loading_message,
    isJuridica,
    setIsJuridica,
    checked,
    data_inicio,
    setDataInicio,
    data_inicio_agenda,
    setDataInicioAgenda,
    data_texto,
    cod_retorno_integracao,
    motivo_integracao,
    prazos,
    formas_pagamento,
    grupo_clientes,
    vendedores,
    tabela_precos,
    bloquear_alteracao_prazo,
    bloquear_alteracao_forma_pagamento,
    bloquear_alteracao_grupo_clientes,
    bloquear_alteracao_tabela_preco,
    prazo_id,
    forma_pagamento_id,
    grupo_clientes_id,
    tabela_preco_id,
    role,
    handleSubmit,
    buscaCepViacep,
    pesquisaEnderecoViacep,
    findCpfCnpj,
    handleIsento,
  } = useClienteCadastro(id);

  const pessoaConfig = getPessoaConfig(isJuridica);

  return (
    <Container>
      <Loading isLoading={!!loading_message || isLoading} />
      <Voltar>
        <Link to="/clientes/lista" title="Voltar para a listagem de clientes">
          <UndoIcon fontSize="large" />
        </Link>
      </Voltar>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <HeaderCadastro>
          <div>
            <h1>{id ? STRINGS.titulo.editar : STRINGS.titulo.novo}</h1>
          </div>
          <div>
            <span>{STRINGS.camposObrigatorios}</span>
          </div>
        </HeaderCadastro>
        <BodyCadastro>
          <Grid
            container
            spacing={1}
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
          >
            <Grid item xs={8} sm={8} md={3} lg={3}>
              <Select
                label={STRINGS.inputs.tipoPessoa}
                isSearchable={false}
                options={tipoPessoa}
                value={isJuridica ? tipoPessoa[1] : tipoPessoa[0]}
                onChange={(option: OptionTypeBase | null) =>
                  option ? setIsJuridica(option.value) : undefined
                }
                name="pessoa.juridica"
              />
            </Grid>
            {id && (
              <Grid item xs={4} sm={4} md={2} lg={2}>
                <Select
                  label={STRINGS.inputs.status}
                  isSearchable={false}
                  options={statusOptions}
                  name="ativo"
                />
              </Grid>
            )}
          </Grid>

          <Grid item xs={8} sm={8} md={3} lg={3}>
            <InputMasked
              key={isJuridica ? 'cnpj' : 'cpf'}
              name="pessoa.cpf_cnpj"
              mask={pessoaConfig.cpf_cnpj.mask}
              placeholder={pessoaConfig.cpf_cnpj.placeholder}
              label={pessoaConfig.cpf_cnpj.label}
              formatChars={isJuridica ? CNPJ_FORMAT_CHARS : undefined}
              style={isJuridica ? { textTransform: 'uppercase' } : undefined}
              onBlur={e => findCpfCnpj(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={10} lg={10}>
            <Input
              name="pessoa.nome"
              label={pessoaConfig.nome.label}
              maxLength={pessoaConfig.nome.maxLength}
              placeholder={pessoaConfig.nome.placeholder}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={10} lg={10}>
            <Input
              name="pessoa.apelido"
              label={pessoaConfig.apelido.label}
              maxLength={pessoaConfig.apelido.maxLength}
              placeholder={pessoaConfig.apelido.placeholder}
            />
          </Grid>
          <Grid
            container
            spacing={1}
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}
          >
            <Grid item xs={8} sm={8} md={3} lg={3}>
              <Input
                name="pessoa.rg_insc"
                label={pessoaConfig.rg_insc.label}
                maxLength={pessoaConfig.rg_insc.maxLength}
                placeholder={pessoaConfig.rg_insc.placeholder}
                disabled={checked}
                pattern="[0-9]*"
              />
            </Grid>
            <Grid
              item
              xs={4}
              sm={4}
              md={2}
              lg={2}
              style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
            >
              <CheckboxInput
                name="isento"
                label={STRINGS.inputs.isento}
                value="isento"
                checked={checked}
                onChange={handleIsento}
              />
            </Grid>
          </Grid>

          <Separador>
            <h2>
              <LocationOnIcon />
              &nbsp;{STRINGS.secoes.endereco}
            </h2>
          </Separador>
          <Inline>
            <Grid item xs={4} sm={4} md={2} lg={2}>
              <InputMasked
                mask="99.999-999"
                label={STRINGS.inputs.cep}
                name="pessoa.endereco.cep"
                placeholder={STRINGS.placeholders.cep}
                onBlur={e => buscaCepViacep(e.target.value)}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={2}>
              <ModalPesquisaEndereco pesquisaCep={pesquisaEnderecoViacep} />
            </Grid>
          </Inline>
          <Input name="pessoa.endereco.codigo_ibge" style={{ display: 'none' }} />
          <Grid item xs={12} sm={12} md={10} lg={10}>
            <Input
              label={STRINGS.inputs.logradouro}
              name="pessoa.endereco.logradouro"
              maxLength={80}
              placeholder={STRINGS.placeholders.logradouro}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2} lg={2}>
            <Input
              label={STRINGS.inputs.numero}
              name="pessoa.endereco.numero"
              maxLength={15}
              placeholder={STRINGS.placeholders.numero}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Input
              label={STRINGS.inputs.complemento}
              name="pessoa.endereco.complemento"
              maxLength={50}
              placeholder={STRINGS.placeholders.complemento}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Input
              label={STRINGS.inputs.bairro}
              name="pessoa.endereco.bairro"
              maxLength={50}
              placeholder={STRINGS.placeholders.bairro}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Input
              disabled
              label={STRINGS.inputs.cidade}
              name="pessoa.endereco.cidade"
              placeholder={STRINGS.placeholders.cidade}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={1} lg={1}>
            <Input
              disabled
              label={STRINGS.inputs.uf}
              name="pessoa.endereco.estado"
              placeholder={STRINGS.placeholders.uf}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextArea
              name="observacao_entrega"
              label={STRINGS.inputs.observacaoEntrega}
              maxLength={500}
              rows={1}
            />
          </Grid>

          <Separador>
            <h2>
              <PermContactCalendarIcon />
              &nbsp;{STRINGS.secoes.contatos}
            </h2>
          </Separador>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Input
              icon={FiPhone}
              placeholder={STRINGS.placeholders.telefone}
              label={STRINGS.inputs.telefoneCelular}
              name="pessoa.contato.telefone"
              maxLength={20}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Input
              icon={FiPhone}
              placeholder={STRINGS.placeholders.telefone}
              label={STRINGS.inputs.telefoneCelular}
              name="pessoa.contato.celular"
              maxLength={20}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Input
              icon={FiMail}
              label={STRINGS.inputs.email}
              name="pessoa.contato.email"
              maxLength={500}
              placeholder={STRINGS.placeholders.email}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Input
              label={STRINGS.inputs.contatoAdicional}
              name="pessoa.contato.outros"
              maxLength={500}
              placeholder={STRINGS.placeholders.contatoAdicional}
            />
          </Grid>

          <Separador>
            <h2>
              <InfoIcon />
              &nbsp;{STRINGS.secoes.infoComplementares}
            </h2>
          </Separador>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Select
              name="prazo_id"
              isSearchable={false}
              label={STRINGS.inputs.prazo}
              options={[{ value: null, label: STRINGS.inputs.nenhumaOpcao }, ...prazos]}
              placeholder={STRINGS.placeholders.prazo}
              isDisabled={!!(id && bloquear_alteracao_prazo && role === 'customer-user' && prazo_id)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Select
              name="forma_pagamento_id"
              isSearchable={false}
              label={STRINGS.inputs.formaPagamento}
              options={[{ value: null, label: STRINGS.inputs.nenhumaOpcao }, ...formas_pagamento]}
              placeholder={STRINGS.placeholders.formaPagamento}
              isDisabled={!!(id && bloquear_alteracao_forma_pagamento && role === 'customer-user' && forma_pagamento_id)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Select
              name="grupo_cliente_id"
              isSearchable={false}
              label={STRINGS.inputs.grupoClientes}
              options={grupo_clientes}
              placeholder={STRINGS.placeholders.grupoClientes}
              isDisabled={!!(id && bloquear_alteracao_grupo_clientes && role === 'customer-user' && grupo_clientes_id)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Select
              name="tabela_preco_id"
              isSearchable={false}
              label={STRINGS.inputs.tabelaPrecos}
              options={[{ value: null, label: STRINGS.inputs.nenhumaOpcao }, ...tabela_precos]}
              placeholder={STRINGS.placeholders.tabelaPrecos}
              isDisabled={!!(id && bloquear_alteracao_tabela_preco && role === 'customer-user' && tabela_preco_id)}
            />
          </Grid>
          <Can roles={['customer-admin']}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Select
                name="vendedor_id"
                isSearchable={false}
                label={STRINGS.inputs.vendedor}
                options={[{ value: null, label: STRINGS.inputs.nenhumaOpcao }, ...vendedores]}
                placeholder={STRINGS.placeholders.vendedor}
              />
            </Grid>
          </Can>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextArea
              name="observacao"
              label={STRINGS.inputs.observacao}
              maxLength={500}
              rows={1}
            />
          </Grid>

          <Separador>
            <h2>
              <CalendarIcon />
              &nbsp;{STRINGS.secoes.agenda}
            </h2>
          </Separador>
          <Grid container spacing={1} style={{ padding: 0, margin: '0' }}>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              lg={3}
              style={{ display: 'flex', marginTop: 15, alignItems: 'flex-end' }}
            >
              <DateTime
                label={STRINGS.inputs.dataInicio}
                value={data_inicio_agenda}
                format="dd/MM/yyyy hh:mm"
                setValue={setDataInicioAgenda}
                name={STRINGS.inputs.dataInicio}
              />
            </Grid>
            <Grid item xs={8} sm={8} md={3} lg={3}>
              <Select
                label={STRINGS.inputs.frequencia}
                options={[
                  { value: null, label: STRINGS.inputs.nenhumaOpcao },
                  ...freqOptions,
                ]}
                isSearchable={false}
                value={retornaObjeto(freqOptions, data_inicio ?? undefined)}
                onChange={e => setDataInicio(e?.value ?? null)}
                name="periodicidade"
                placeholder={STRINGS.inputs.nenhumaOpcao}
              />
            </Grid>
          </Grid>
          {data_inicio_agenda && data_inicio ? (
            <ContainerInfo>
              <TextInfo>
                {STRINGS.agenda.eventoInfo(
                  <TextEvento>{periodicidadeParaTexto(data_inicio)}</TextEvento> as any,
                  <TextEvento>{data_texto}</TextEvento> as any,
                )}
              </TextInfo>
            </ContainerInfo>
          ) : null}
        </BodyCadastro>
        <FooterCadastro>
          {id && (
            <StatusSincronizacao
              tipo="cliente"
              id={Number(id)}
              cod_retorno_integracao={cod_retorno_integracao}
              motivo_integracao={motivo_integracao}
            />
          )}
          <BotaoSalvar loading={loading_message} type="submit">
            {STRINGS.salvar}
          </BotaoSalvar>
        </FooterCadastro>
      </Form>
      <BotaoNovoPedidoRodape />
    </Container>
  );
};

export default CadastroClientes;
